export default __webpack_public_path__ + "static/media/main4.379939ad.png";